// extracted by mini-css-extract-plugin
export default {"container":"uda-z","creativeContainer":"vda-z","copy":"wda-z","cta":"xda-z","disabled":"yda-z","flipped":"zda-z","productCard":"Ada-z"};